import { fetcher } from '@commenda/utils';

export const retireBillingBundle = async (bundleId: string) => {
  const response = await fetcher(`commenda-billing/catalog/bundles/${bundleId}/retire`, {
    method: 'POST',
  });

  return response;
};
